/**
 * PipelinesSection — the Pipelines band on the Models page (TRA-863).
 *
 * A pipeline is the platform's other deployment type: a whole document
 * pipeline behind a batch endpoint rather than a model behind a chat one,
 * so it lists beside the models. Visibility is data-driven: a team holds
 * a pipeline only when staff granted it, and most teams hold none, so the
 * band renders nothing for them and never needs a nav or config switch.
 */

import { getApiErrorDetail } from '@/api/client'
import { SectionHeading } from '@/components/models/home/ModelHomeSection'
import { usePipelines } from '@/hooks/usePipelines'

import { PipelinesTable } from './PipelinesTable'

export function PipelinesSection(): React.JSX.Element | null {
  const pipelines = usePipelines()
  const granted = pipelines.data?.pipelines ?? []

  if (pipelines.isError) {
    return (
      <p className="text-sm text-destructive">
        Failed to load pipelines: {getApiErrorDetail(pipelines.error) ?? 'unknown error'}
      </p>
    )
  }
  if (granted.length === 0) return null

  return (
    <section className="space-y-3">
      <SectionHeading
        title="Pipelines"
        subtitle="Pipelines your team can run over files in an S3 bucket."
      />
      <div className="rounded-md border border-border">
        <PipelinesTable pipelines={granted} />
      </div>
    </section>
  )
}
